import useErrorMessageHandler from '@/@core/helpers/errorMessageHandler';
import { useCallApi } from '@/@core/services/axiosCall';
import {
  reactive,
  Ref,
  ref,
  toRefs,
  unref
} from '@vue/composition-api';
import { defineStore } from 'pinia';

export const useMarketingAreaStore = defineStore('marketing-area', () => {
  const state = reactive({
    total: 0,
    marketingAreas: []
  });

  async function getManyMarketingArea() {
    const { errorMessage, result, error } = await useCallApi({
      method: 'get',
      url: '/marketing-areas'
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    state.marketingAreas = result.marketingAreas;
    state.total = result.count;

    return result;
  }

  async function postMarketingArea(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'post',
      url: '/marketing-areas',
      data: unref(data)
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }

  async function putMarketingArea(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'put',
      url: '/marketing-areas/' + data.id,
      data: unref(data)
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }

  async function deleteMarketingArea(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'delete',
      url: '/marketing-areas/' + data.id
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }
  return {
    ...toRefs(state),
    getManyMarketingArea,
    postMarketingArea,
    deleteMarketingArea,
    putMarketingArea
  };
});
